var EHDI = EHDI || Object.create(null);

EHDI.util = EHDI.util || Object.create(null);

EHDI.util.Time = function () {
  this._lastTime;
  this._pauseTime;
  this._pause;
  this._lastFrameTime;
  this._date;

  this._pause = false;
  this._lastTime = new Date().getTime();
  this._lastFrameTime = new Date().getTime();
};

EHDI.util.Time.prototype.reset = function () {
  this._pause = false;
  this._lastTime = new Date().getTime();
  this._lastFrameTime = new Date().getTime();
};

EHDI.util.Time.prototype.addAdditionalTime = function (timeInMilliseconds) {
  this._lastTime -= timeInMilliseconds;
};

EHDI.util.Time.prototype.resetLastTime = function (addToLastTime) {
  this._lastTime -= new Date().getTime() - addToLastTime;
};

EHDI.util.Time.prototype.getDelta = function () {
  var delta = new Date().getTime() - this._lastFrameTime;

  delta = delta / 10;
  this.resetLastFrameTime();

  return delta;
};

EHDI.util.Time.prototype.resetLastFrameTime = function () {
  lastFrameTime = new Date().getTime();
};

EHDI.util.Time.prototype.pause = function (pause) {
  if (pause && !this._pause) {
		this._pause = true;
		this._pauseTime = new Date().getTime() - this._lastTime;
	} else if(!pause && this._pause) {
		this._pause = false;
		this._lastTime = new Date().getTime() - this._pauseTime;
		this._lastFrameTime = new Date().getTime();
	}
};

EHDI.util.Time.prototype.getTimeInMilliseconds = function () {
  var time;

  if(!this._pause)
    time = new Date().getTime() - this._lastTime;
  else
    time = this._pauseTime;

  return parseInt(time);
};

EHDI.util.Time.prototype.getTime = function () {
  var time;

  if(!this._pause)
    time = new Date().getTime() - this._lastTime;
  else
    time = this._pauseTime;

  return parseInt(time);
};

EHDI.util.Time.prototype.getTimeInSeconds = function () {
  var time;

  if(!this._pause)
    time = new Date().getTime() - this._lastTime;
  else
    time = this._pauseTime;

    time = time / 1000;
  return parseInt(time);
};

EHDI.util.Time.prototype.getPercentageOfCurrentTimeOverGivenTime = function (timeInMilliSeconds) {
  var percentageToReturn;

  percentageToReturn = this.getTimeInMilliseconds() / timeInMilliSeconds;

  if (percentageToReturn > 1)
    percentageToReturn = 1;

  return percentageToReturn;
};

EHDI.util.Time.prototype.addValueToLastTime = function (val) {
  if (val + this._lastTime > new Date().getTime())
			this._lastTime = new Date().getTime();
	else
		this._lastTime += val;
};

EHDI.util.Time.prototype.destroy = function () {
  this.lastTime = null;
  this.pauseTime = null;
  this.onPause = null;
  this.lastFrameTime = null;
};
